import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useApp, LANGS } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { myPart2 } from "@/lib/api";

export default function PLayout({ children }) {
  const { user, logout, lang, setLang } = useApp();
  const t = useAppUi(lang);
  const [part2, setPart2] = useState(false);
  useEffect(() => { myPart2().then((d) => setPart2(!!d.access)).catch(() => {}); }, []);
  const NAV = [
    ["/app", t("navDashboard"), "dashboard", true],
    ["/app/part1", t("navPart1"), "part1"],
    ...(part2 ? [["/app/part2", t("navPart2"), "part2"]] : []),
    ["/app/worksheets", t("navWorksheets"), "worksheets"],
    ["/app/quizzes", t("navQuizzes"), "quizzes"],
    ["/app/journal", t("navJournal"), "journal"],
    ["/app/program", t("navProgram"), "program"],
  ];
  return (
    <div className="rbl" data-testid="participant-app">
      <header className="rbl-topbar">
        <div className="rbl-topbar-inner">
          <div className="rbl-logos">
            <Link to="/app"><img className="rbl-logo" src="/logo_rbl.png" alt="RBL Training" /></Link>
          </div>
          <nav className="rbl-pnav">
            {NAV.map(([to, label, id, end]) => (
              <NavLink key={to} to={to} end={!!end} data-testid={`pnav-${id}`}
                className={({ isActive }) => (isActive ? "active" : "")}>{label}</NavLink>
            ))}
          </nav>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <div className="rbl-langs" role="tablist" aria-label="Language">
              {LANGS.map((l) => (
                <button key={l.code} data-testid={`lang-${l.code}`}
                  className={`rbl-lang-btn ${lang === l.code ? "active" : ""}`} onClick={() => setLang(l.code)}>{l.label}</button>
              ))}
            </div>
            <span className="rbl-user-name">{user?.full_name}</span>
            <button className="rbl-link" onClick={logout} data-testid="logout-btn" style={{ border: "none", background: "none" }}>{t("signOut")}</button>
          </div>
        </div>
      </header>
      <div className="rbl-wrap" style={{ paddingTop: 32, paddingBottom: 50 }}>{children}</div>
    </div>
  );
}
